<template>
  <div class="wrapper bg-grey-lightest main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel max-center" style="overflow: auto">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 100px"
        >
          <div class="options">
            <div class="content-title-wrap justify-content-between">
              <div class="main-content-title">Overview</div>
              <PeriodCompare />
            </div>
          </div>
        </div>
        <div class="main-bg p-0 m-t-0 m-b-l">
          <div class="pannel-1 flex-row flex">
            <div class="flex-3">
              <div class="pannel-1-body m-t-l">
                <div class="flex flex-row">
                  <div class="overView-revenue m-r-60">
                    <h3>
                      Revenue MTD
                      <i class="material-icons align-middle">arrow_drop_down</i>
                    </h3>
                    <p>{{ revenue | currencyFilter("$", 2) }}</p>
                  </div>
                  <div class="overView-revenue m-r-60">
                    <h3>
                      Revenue Last Period
                      <i class="material-icons align-middle">arrow_drop_down</i>
                    </h3>
                    <p class="font-color-lighter">
                      {{ last_month_revenue | currencyFilter("$", 2) }}
                    </p>
                  </div>
                </div>
                <div style="height: 150px">
                  <v-chart class="chart" :option="optionRevenue" />
                </div>
              </div>
            </div>
            <div class="flex-1" style="border-left: 1px solid #e8e8e8">
              <div class="pannel-1-body m-t-l">
                <div class="overView-revenue">
                  <h3>
                    Revenue
                    <i class="material-icons align-middle">arrow_drop_down</i>
                  </h3>
                  <p>{{ last_month_revenue | currencyFilter("$", 2) }}</p>
                  <div>Bookled hours from Techs</div>
                </div>
                <div
                  class="hr m-t-l m-b-l"
                  style="margin-left: -20px; margin-right: -20px"
                ></div>
                <div class="overView-revenue">
                  <h3>Labor Cost</h3>
                  <p>{{ labor_cost | currencyFilter("$", 2) }}</p>
                  <div>Cost from tech labor rate</div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-row" style="margin: 0 -10px">
            <div class="flex-1 card" style="padding: 0 10px">
              <div class="pannel-1">
                <div class="pannel-1-title small">
                  <h3>Total Consultants</h3>
                  <div class="pannel-1-title-option">
                    <a class="btn" href="javascript:void(0);">View</a>
                  </div>
                </div>
                <div class="pannel-1-body">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      <div class="overView-info-pannel flex flex-row">
                        <h3>{{ consultants.length }}</h3>
                        <div v-if="consultants_percent">
                          <div class="point-tag">
                            <span v-if="consultants_percent >= 0" class="up"
                              ><i class="material-icons align-middle"
                                >arrow_upward</i
                              >{{
                                (consultants_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                            <span v-if="consultants_percent < 0" class="down"
                              ><i class="material-icons align-middle"
                                >arrow_downward</i
                              >{{
                                (consultants_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="m-t-l" style="height: 180px">
                    <v-chart class="chart" :option="optionConsultant" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 card" style="padding: 0 10px">
              <div class="pannel-1">
                <div class="pannel-1-title small">
                  <h3>Active Projects</h3>
                  <div class="pannel-1-title-option">
                    <a class="btn" href="javascript:void(0);">View</a>
                  </div>
                </div>
                <div class="pannel-1-body">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      <div class="overView-info-pannel flex flex-row">
                        <h3>{{ projects.length }}</h3>
                        <div v-if="projects_percent">
                          <div class="point-tag">
                            <span v-if="projects_percent >= 0" class="up"
                              ><i class="material-icons align-middle"
                                >arrow_upward</i
                              >{{
                                (projects_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                            <span v-if="projects_percent < 0" class="down"
                              ><i class="material-icons align-middle"
                                >arrow_downward</i
                              >{{
                                (projects_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="overView-info-pannel flex flex-row">
                        <h3>{{ Math.floor(projects_amount / 1000) + "K" }}</h3>
                        <div>
                          <div class="point-tag">
                            <span v-if="projects_amount_percent >= 0" class="up"
                              ><i class="material-icons align-middle"
                                >arrow_upward</i
                              >{{
                                (projects_amount_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                            <span
                              v-if="projects_amount_percent < 0"
                              class="down"
                              ><i class="material-icons align-middle"
                                >arrow_downward</i
                              >{{
                                (projects_amount_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="m-t-l" style="height: 180px">
                    <v-chart class="chart" :option="optionProjects" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 card" style="padding: 0 10px">
              <div class="pannel-1">
                <div class="pannel-1-title small">
                  <h3>Active Clients</h3>
                  <div class="pannel-1-title-option">
                    <a class="btn" href="javascript:void(0);">View</a>
                  </div>
                </div>
                <div class="pannel-1-body">
                  <div class="flex flex-row">
                    <div class="flex-1">
                      <div class="overView-info-pannel flex flex-row">
                        <h3>{{ clients.length }}</h3>
                        <div v-if="clients_percent">
                          <div class="point-tag">
                            <span v-if="clients_percent >= 0" class="up"
                              ><i class="material-icons align-middle"
                                >arrow_upward</i
                              >{{
                                (clients_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                            <span v-if="clients_percent < 0" class="down"
                              ><i class="material-icons align-middle"
                                >arrow_downward</i
                              >{{
                                (clients_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1">
                      <div class="overView-info-pannel flex flex-row">
                        <h3>
                          {{ Math.floor(clients_invoice_amount / 1000) + "K" }}
                        </h3>
                        <div
                          v-if="
                            clients_invoice_percent !== undefined &&
                            clients_invoice_percent !== null
                          "
                        >
                          <div class="point-tag">
                            <span v-if="clients_invoice_percent >= 0" class="up"
                              ><i class="material-icons align-middle"
                                >arrow_upward</i
                              >{{
                                (clients_invoice_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                            <span
                              v-if="clients_invoice_percent < 0"
                              class="down"
                              ><i class="material-icons align-middle"
                                >arrow_downward</i
                              >{{
                                (clients_invoice_percent * 100).toFixed(2) + "%"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="m-t-l" style="height: 180px">
                    <v-chart class="chart" :option="optionClients" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Projects
            :propsData="overview_projects"
            @onCreateInvoice="onCreateInvoiceClick"
          />
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelCompanyInvoice
            v-if="editOpen == 1"
            @buttonClick="onInvoiceButtonClick"
            @closePanel="closeEditPannel"
          ></PanelCompanyInvoice>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  AxisPointerComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import PeriodCompare from "@/components/PeriodCompare";
import moment from "moment";
import { db } from "@/vendor/firebase";
import Projects from "@/components/admin/overviewAdmin/Projects";
import PanelCompanyInvoice from "@/components/admin/overviewAdmin/PanelCompanyInvoice.vue";
import { httpGet } from "@/http/http";

use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  AxisPointerComponent,
  CanvasRenderer,
  LineChart,
]);

export default {
  props: ["editOpenTitle"],
  components: {
    EditPannel,
    OptionMenu,
    PanelCompanyInvoice,
    VChart,
    PeriodCompare,
    Projects,
  },
  data() {
    return {
      revenue: 0,
      last_month_revenue: 0,
      total_revenue: 0,
      revenue_data: [],
      last_month_revenue_data: [],
      revenue_option: [],
      last_month_revenue_option: [],
      consultants: [],
      filtered_consultants: [],
      this_month_consultants: [],
      last_month_consultants: [],
      consultants_percent: 0,
      projects: [],
      filtered_projects: [],
      this_month_projects: [],
      last_month_projects: [],
      projects_percent: 0,
      projects_amount_percent: 0,
      projects_amount: 0,
      clients: [],
      filtered_clients: [],
      this_month_clients: [],
      last_month_clients: [],
      clients_percent: 0,
      labor_cost: 0,
      clients_invoice_amount: 0,
      clients_invoice_percent: null,
      overview_data: null,
      overview_projects: null,
      editOpen: false,
      editInvoiceCompanyId: null,
      editInvoiceProjectId: null,
      companyInvoiceSubmitLoading: false,
    };
  },
  computed: {
    optionRevenue: function () {
      return {
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
          axisLabel: {
            formatter: function (value) {
              // return moment(value).date() + "";
              return value + "";
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        grid: {
          left: 20,
          right: 20,
          bottom: 20,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              formatter: function (value) {
                if (value.axisDimension === "x") {
                  // return moment(value.value).format("MM/DD/YYYY");
                  return value.value + "";
                } else if (value.axisDimension === "y") {
                  return Math.floor(Number(value.value));
                }
              },
            },
          },
        },
        series: [
          {
            name: "Revenue MTD",
            data: this.revenue_option,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#0085FF",
            },
          },
          {
            name: "Revenue Last Period",
            data: this.last_month_revenue_option,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#969696",
            },
          },
        ],
      };
    },
    optionConsultant: function () {
      return {
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
          axisLabel: {
            formatter: function (value) {
              // return moment(value).date() + "";
              return value + "";
            },
          },
        },
        yAxis: {
          type: "value",
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
        },
        legend: {
          data: ["Cumulative", "Monthly Growth"],
          bottom: 0,
          right: 0,
        },
        grid: {
          left: 30,
          right: 20,
          bottom: 50,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              formatter: function (value) {
                if (value.axisDimension === "x") {
                  // return moment(value.value).format("MM/DD/YYYY");
                  return value.value + "";
                } else if (value.axisDimension === "y") {
                  return Math.floor(Number(value.value));
                }
              },
            },
          },
        },
        series: [
          {
            name: "Cumulative",
            data: this.this_month_consultants,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#0085FF",
            },
          },
          {
            name: "Monthly Growth",
            data: this.last_month_consultants,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#969696",
            },
          },
        ],
      };
    },
    optionProjects: function () {
      return {
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
          axisLabel: {
            formatter: function (value) {
              // return moment(value).date() + "";
              return value + "";
            },
          },
        },
        yAxis: {
          type: "value",
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
        },
        legend: {
          data: ["Cumulative", "Monthly Growth"],
          bottom: 0,
          right: 0,
        },
        grid: {
          left: 30,
          right: 20,
          bottom: 50,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              formatter: function (value) {
                if (value.axisDimension === "x") {
                  // return moment(value.value).format("MM/DD/YYYY");
                  return value.value + "";
                } else if (value.axisDimension === "y") {
                  return Math.floor(Number(value.value));
                }
              },
            },
          },
        },
        series: [
          {
            name: "Cumulative",
            data: this.this_month_projects,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#0085FF",
            },
          },
          {
            name: "Monthly Growth",
            data: this.last_month_projects,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#969696",
            },
          },
        ],
      };
    },
    optionClients: function () {
      return {
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
          axisLabel: {
            formatter: function (value) {
              // return moment(value).date() + "";
              return value + "";
            },
          },
        },
        yAxis: {
          type: "value",
          scale: true,
          axisLine: {
            lineStyle: {
              color: "#E8E8E8",
            },
          },
        },
        legend: {
          data: ["Cumulative", "Monthly Growth"],
          bottom: 0,
          right: 0,
        },
        grid: {
          left: 30,
          right: 20,
          bottom: 50,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              formatter: function (value) {
                if (value.axisDimension === "x") {
                  // return moment(value.value).format("MM/DD/YYYY");
                  return value.value + "";
                } else if (value.axisDimension === "y") {
                  return Math.floor(Number(value.value));
                }
              },
            },
          },
        },
        series: [
          {
            name: "Cumulative",
            data: this.this_month_clients,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#0085FF",
            },
          },
          {
            name: "Monthly Growth",
            data: this.last_month_clients,
            type: "line",
            smooth: 0.3,
            lineStyle: {
              color: "#969696",
            },
          },
        ],
      };
    },
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    overview_data: function () {
      // return;
      if (this.overview_data) {
        (this.overview_data || []).forEach((item) => {
          if (item.id === "revenue") {
            this.labor_cost = item.transfer_amount;
            this.revenue = item.revenue;
            this.last_month_revenue = item.last_month_revenue;
            this.total_revenue = item.total_revenue;
            this.revenue_data = item.revenue_data;
            this.last_month_revenue_data = item.last_month_revenue_data;
            if (item.revenue_data && item.revenue_data.length > 0) {
              // const days = moment(
              //   item.revenue_data[0].created * 1000
              // ).daysInMonth();
              const date = moment(item.revenue_data[0].created * 1000);
              const days = date.daysInMonth();
              this.revenue_option = Array.from(Array(days)).map((_, index) => {
                if (moment().date() < index + 1) return;
                const amount = item.revenue_data.reduce((pre, cur) => {
                  if (moment(cur.created * 1000).date() <= index) {
                    return pre + cur.amount;
                  }
                  return pre;
                }, 0);
                return [
                  // date
                  //   .clone()
                  //   .set("date", index + 1)
                  //   .valueOf(),
                  index + 1,
                  amount.toFixed(2),
                ];
              });
            }
            if (
              item.last_month_revenue_data &&
              item.last_month_revenue_data.length > 0
            ) {
              const date = moment(
                item.last_month_revenue_data[0].created * 1000
              );
              const days = date.daysInMonth();
              this.last_month_revenue_option = Array.from(Array(days)).map(
                (_, index) => {
                  const amount = item.last_month_revenue_data.reduce(
                    (pre, cur) => {
                      if (moment(cur.created * 1000).date() <= index) {
                        return pre + cur.amount;
                      }
                      return pre;
                    },
                    0
                  );
                  return [
                    // date
                    //   .clone()
                    //   .set("date", index + 1)
                    //   .valueOf(),
                    index + 1,
                    amount.toFixed(2),
                  ];
                }
              );
            }
          }
          if (item.id === "invoice") {
            this.clients_invoice_amount = item.last_month_amount;
            this.clients_invoice_percent =
              (item.last_month_amount - item.pre_month_amount) /
              item.pre_month_amount;
          }
          if (item.id === "projects_new") {
            this.overview_projects = item;
          }
        });
      }
    },
    consultants: function () {
      // this.filtered_consultants = (this.consultants || []).filter((item))
      this.this_month_consultants = [];
      this.last_month_consultants = [];
      const this_month_data = [];
      const last_month_data = [];
      const last_month = moment().subtract(1, "months").startOf("month");
      const this_month = moment().startOf("month");
      let pre_count = 0;
      let last_month_count = 0;
      this.consultants.forEach((item) => {
        let created = item.created;
        if (created) {
          created = created * 1000;
          if (created >= this_month.valueOf()) {
            this_month_data.push(created);
          } else if (
            created >= last_month.valueOf() &&
            item.created < this_month.valueOf()
          ) {
            last_month_data.push(created);
            last_month_count++;
          } else {
            pre_count++;
          }
        } else {
          pre_count++;
        }
      });
      if (this.consultants && this.consultants.length > 0) {
        const date = moment();
        const days = date.daysInMonth();
        this.this_month_consultants = Array.from(Array(days)).map(
          (item, index) => {
            if (moment().date() < index + 1) return;
            const count = this_month_data.reduce((pre, cur) => {
              if (moment(cur).date() <= index + 1) {
                return pre + 1;
              }
              return pre;
            }, 0);
            return [index + 1, pre_count + last_month_count + count];
          }
        );
      }
      if (this.consultants && this.consultants.length > 0) {
        const date = moment().subtract(1, "month");
        const days = date.daysInMonth();
        this.last_month_consultants = Array.from(Array(days)).map(
          (item, index) => {
            const count = last_month_data.reduce((pre, cur) => {
              if (moment(cur).date() <= index + 1) {
                return pre + 1;
              }
              return pre;
            }, 0);
            return [index + 1, pre_count + count];
          }
        );
      }
      this.consultants_percent = this.getPercentage(
        this.this_month_consultants,
        this.last_month_consultants
      );
    },
    projects: function () {
      this.this_month_projects = [];
      this.last_month_projects = [];
      const this_month_data = [];
      const last_month_data = [];
      const last_month = moment().subtract(1, "months").startOf("month");
      const this_month = moment().startOf("month");
      let pre_count = 0;
      let last_month_count = 0;
      let pre_amount = 0;
      let this_month_amount = 0;
      let last_month_amount = 0;
      this.projects.forEach((item) => {
        let created = item.created;
        if (created) {
          created = created * 1000;
          if (created >= this_month.valueOf()) {
            this_month_data.push(created);
            const roles = item.roles;
            (roles || []).forEach((role) => {
              this_month_amount = this_month_amount + this.getRoleAmount(role);
            });
          } else if (
            created >= last_month.valueOf() &&
            item.created < this_month.valueOf()
          ) {
            last_month_count++;
            last_month_data.push(created);
            const roles = item.roles;
            (roles || []).forEach((role) => {
              last_month_amount = last_month_amount + this.getRoleAmount(role);
            });
          } else {
            pre_count++;
            const roles = item.roles;
            (roles || []).forEach((role) => {
              pre_amount = pre_amount + this.getRoleAmount(role);
            });
          }
        } else {
          pre_count++;
          const roles = item.roles;
          (roles || []).forEach((role) => {
            pre_amount = pre_amount + this.getRoleAmount(role);
          });
        }
      });
      if (this.projects && this.projects.length > 0) {
        const date = moment();
        const days = date.daysInMonth();
        this.this_month_projects = Array.from(Array(days)).map(
          (item, index) => {
            if (moment().date() < index + 1) return;
            const count = this_month_data.reduce((pre, cur) => {
              if (moment(cur).date() <= index + 1) {
                return pre + 1;
              }
              return pre;
            }, 0);
            return [index + 1, pre_count + last_month_count + count];
          }
        );
      }
      if (this.projects && this.projects.length > 0) {
        const date = moment().subtract(1, "month");
        const days = date.daysInMonth();
        this.last_month_projects = Array.from(Array(days)).map(
          (item, index) => {
            const count = last_month_data.reduce((pre, cur) => {
              if (moment(cur).date() <= index + 1) {
                return pre + 1;
              }
              return pre;
            }, 0);
            return [index + 1, pre_count + count];
          }
        );
      }
      this.projects_percent = this.getPercentage(
        this.this_month_projects,
        this.last_month_projects
      );
      this.projects_amount_percent =
        this_month_amount / (last_month_amount + pre_amount);
      this.projects_amount = this_month_amount + last_month_amount + pre_amount;
    },
    clients: function () {
      this.this_month_clients = [];
      this.last_month_clients = [];
      const this_month_data = [];
      const last_month_data = [];
      const last_month = moment().subtract(1, "months").startOf("month");
      const this_month = moment().startOf("month");
      let pre_count = 0;
      let last_month_count = 0;
      this.clients.forEach((item) => {
        let created = item.created;
        if (created) {
          created = created * 1000;
          if (created >= this_month.valueOf()) {
            this_month_data.push(created);
          } else if (
            created >= last_month.valueOf() &&
            item.created < this_month.valueOf()
          ) {
            last_month_count++;
            last_month_data.push(created);
          } else {
            pre_count++;
          }
        } else {
          pre_count++;
        }
      });
      if (this.clients && this.clients.length > 0) {
        const date = moment();
        const days = date.daysInMonth();
        this.this_month_clients = Array.from(Array(days)).map((item, index) => {
          if (moment().date() < index + 1) return;
          const count = this_month_data.reduce((pre, cur) => {
            if (moment(cur).date() <= index + 1) {
              return pre + 1;
            }
            return pre;
          }, 0);
          return [index + 1, pre_count + last_month_count + count];
        });
      }
      if (this.clients && this.clients.length > 0) {
        const date = moment().subtract(1, "month");
        const days = date.daysInMonth();
        this.last_month_clients = Array.from(Array(days)).map((item, index) => {
          const count = last_month_data.reduce((pre, cur) => {
            if (moment(cur).date() <= index + 1) {
              return pre + 1;
            }
            return pre;
          }, 0);
          return [index + 1, pre_count + count];
        });
      }
      this.clients_percent = this.getPercentage(
        this.this_month_clients,
        this.last_month_clients
      );
    },
  },
  beforeMount() {
    this.$bind(
      "consultants",
      db.collection("consultants").where("is_active", "==", true)
    );
    this.$bind(
      "projects",
      db
        .collection("gigs")
        .where("phase", "in", [
          "Active searching",
          "Active ongoing",
          "Active waiting",
        ])
    );
    this.$bind(
      "clients",
      db.collection("companies").where("is_active", "==", true)
    );
    this.$bind("overview_data", db.collection("overview_data"));
    // httpGet("get_revenu_data").then((response) => {});
    // httpGet("get_overview_clients_invoice").then((response) => {});
  },
  methods: {
    getPercentage: function (this_month, last_month) {
      if (!this_month || this_month.length === 0) return 0;
      if (!last_month || last_month.length === 0) return 0;
      const this_month_max = this_month.reduce((pre, cur) => {
        if (!cur) return pre;
        if (cur[1] && cur[1] > pre) {
          return cur[1];
        }
        return pre;
      }, 0);
      const last_month_max = last_month.reduce((pre, cur) => {
        if (!cur) return pre;
        if (cur[1] && cur[1] > pre) {
          return cur[1];
        }
        return pre;
      }, 0);
      const percentage = (
        (this_month_max - last_month_max) /
        last_month_max
      ).toFixed(4);
      return percentage;
    },
    getRoleAmount: function (role) {
      if (!role) return 0;
      const hours_per_week = role.hours_per_week;
      const rate_to_client = role.rate_to_client;
      if (
        hours_per_week &&
        rate_to_client &&
        !isNaN(Number(hours_per_week)) &&
        !isNaN(Number(rate_to_client))
      ) {
        return 4 * Number(hours_per_week) * Number(rate_to_client);
      }
      return 0;
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    onCreateInvoiceClick: function (companyId, projectId) {
      console.log("onCreateInvoiceClick", companyId, projectId);
      this.editInvoiceCompanyId = companyId;
      this.editInvoiceProjectId = projectId;
      this.openEditPannel(1, "Create invoice");
    },
    onInvoiceButtonClick: function (item) {
      const companyId = this.editInvoiceCompanyId;
      const projectId = this.editInvoiceProjectId;
      if (companyId && projectId) {
        this.companyInvoiceSubmitLoading = true;
        httpGet("create_invoice", {
          companyId,
          projectId,
          startTime: item.startTime,
          endTime: item.endTime,
          isFinalized: item.isFinalized,
        })
          .then((response) => {
            if (response.ok) {
              this.$toasted.global.toast_success({
                message: "create success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({
                message: response.message || "create error",
              });
            }
          })
          .finally(() => {
            this.companyInvoiceSubmitLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  max-width: calc(100vw - 321px);
  flex: 1;
  display: flex;
}
.card {
  flex-basis: 33.3%;
  max-width: calc(33.3% - 20px);
}
</style>
